module.exports = __webpack_public_path__ + "static/media/integral_ticket_bg_0.fe541fe0.png";